/***********************************************
 * use bootstrap datepicker
 **********************************************/
var moment = require('moment');
$(document).ready(function () {
    function bindDatepicker() {
        function modifyPostion(width) {
            var winWidth = $(window).width();
            if (winWidth < 480) {
                var element = $('.datepicker.datepicker-dropdown')[0],
                    leftValue = $(element).position().left;

                if (leftValue < 0 || leftValue + width > winWidth) {
                    var newLeft = 0;
                    if (winWidth >= width || leftValue + width > winWidth) {
                        $(element).css({
                            left: newLeft
                        });
                    } else {
                        newLeft = (winWidth - width) / 2;
                        $(element).css({
                            left: newLeft
                        });
                    }

                    var assumpeDiffValue = 110;
                    if (leftValue < 0 && Math.abs(newLeft - leftValue) > assumpeDiffValue) {
                        $(element).removeClass('datepicker-orient-right');
                        $(element).addClass('datepicker-orient-left');
                    }
                }
            }
        }

        $('input.datepicker').each(function () {
            if ($(this).attr('data-cus-placeholder')) {
                $(this).attr('placeholder', $(this).attr('data-cus-placeholder'));
            } else {
                $(this).attr('placeholder', window.MvpFE.globalConfiguration.datePickerPlaceholder || 'DD MMM YYYY');
            }
        });

        var disableTouchKeyboard = true;
        /* eslint-disable */
        if (bowser.msie && bowser.version === "11.0") {
            /* eslint-enable */
            disableTouchKeyboard = false;
        }
        var pickerWidth = 0;
        $('input.datepicker:not(.enter-expire-date)').datepicker({
            format: window.MvpFE.globalConfiguration.datePickerFormat || 'dd M yyyy',
            autoclose: true,
            //forceParse: false, // Remove this for now as it causes enter keyboard support issue which enter key is not working for toggle date into input
            disableTouchKeyboard: disableTouchKeyboard
        }).on('show', function () {
            if (pickerWidth === 0) {
                pickerWidth = $('.datepicker.datepicker-dropdown').width();
            }
            modifyPostion(pickerWidth);
        }).on('changeMonth', function () {
            modifyPostion(pickerWidth);
        });

        // expiry date box
        $('input.datepicker.enter-expire-date').datepicker({
            format: window.MvpFE.globalConfiguration.expirydateFormat || 'mm yy',
            showWeekDays:false,
            autoclose: true,
            minDate: '+1M',
            //forceParse: false, // Remove this for now as it causes enter keyboard support issue which enter key is not working for toggle date into input
            disableTouchKeyboard: disableTouchKeyboard
        }).on('show', function () {           
            $('.datepicker.datepicker-dropdown .datepicker-days tbody').css("display","none")
            if (pickerWidth === 0) {
                pickerWidth = $('.datepicker.datepicker-dropdown').width();
            }
            modifyPostion(pickerWidth);
            $(".datepicker.datepicker-dropdown .datepicker-days tbody").datepicker('update');
        }).on('changeMonth', function (e) {
            modifyPostion(pickerWidth);
            var formatedValue = new Date(e.date);
            $('input.datepicker.enter-expire-date').datepicker('setDate',formatedValue)
        }).on("changeYear",function(e) { 
            modifyPostion(pickerWidth);
            var formatedValue = new Date(e.date);
            $('input.datepicker.enter-expire-date').datepicker('setDate',formatedValue);
        })
    }

    /* - auto insert slash feature, now discard it
    $(document).on('keypress', 'input.datepicker', function (e) {
        // Add (e.which > 31 || e.which > 126) condition for Firefox which capture white characters in this event
        if ((e.which < 48 ||e.which > 57) && (e.which > 31 || e.which > 126)) {
            e.preventDefault();
        }

        var value = $(this).val();
        // Add (e.which > 31 || e.which > 126) condition for Firefox which capture white characters in this event
        if (value.length === 10 && (e.which > 31 || e.which > 126)) {
            e.preventDefault();
        }
    });

    $(document).on('keyup', 'input.datepicker', function (e) {
        console.log("key:" + e.which);
        var value = $(this).val();
        if (e.which !== 8 && (value.length === 2 || value.length === 5)) {
            $(this).val(value + '/');
        }
    });
    */
 
    const expiryDateFormat = "^(0[1-9]|1[0-2])/([0-9]{2})$";

    $(document).on('change', 'input.datepicker:not(.enter-expire-date)', function () {
        var m = moment($(this).val(), window.MvpFE.globalConfiguration.momentExpectFormatGroups || ['DD/MM/YYYY', 'DD MMM YYYY', 'DD MM YYYY'], true);
        if (m.isValid()) {
            $(this).val(m.format(window.MvpFE.globalConfiguration.momentFormat || 'DD MMM YYYY').toUpperCase());
        } 
    });
    $(document).on('change', 'input.datepicker.enter-expire-date', function () {
        let input = $(this).val();
        var expiryOriginalFormated = input.match(expiryDateFormat) 
        if(!expiryOriginalFormated){           
            return;
        } 
        var m = moment($(this).val(), window.MvpFE.globalConfiguration.momentExpectFormatGroups.concat(window.MvpFE.globalConfiguration.expirydateFormat,"MM/YY") || ['DD/MM/YYYY', 'DD MMM YYYY', 'DD MM YYYY', 'MM/YYYY'], true);
        if (m.isValid() && expiryOriginalFormated) {
            $('.manage-cards .active-card-btn').removeClass('d-none');
            return;
        } 
        if (m.isValid()) {
            $(this).val(m.format(window.MvpFE.globalConfiguration.momentFormat || 'DD MMM YYYY').toUpperCase());
        } 
    });
    $(document).on('keyup', 'input.datepicker.enter-expire-date', function () {
        let input = $(this).val();
        var expiryOriginalFormated = input.match(expiryDateFormat) 
        if(!expiryOriginalFormated){
            $('.manage-cards .active-card-btn').addClass('d-none');
            return;
        } 
        var fixeddate =  input.replace("/","/01/20")
        $(this).datepicker("update",new Date(fixeddate))
    });


    bindDatepicker();
    window.MvpFE.rebindFunctions.bindDatepicker = bindDatepicker;
});